export enum WalletActionTypes {
  UpdateWallets = 'UpdateWallets',
  UpdateWalletBalance = 'UpdateWalletBalance',
}
